module.exports = __webpack_public_path__ + "img/snapshot-logo-nav.96ea3a4b.svg";